import { useBack, useBackMultipart } from "../http";
import { AdmissionStatusDTO } from "../types/AdmissionStatusDTO";
import { AuditAdmissionDTO } from "../types/AuditAdmissionDTO";
import { DocumentsGroupDTO } from "../types/DocumentsGroupDTO";
import { EmployeeDTO } from "../types/EmployeeDTO";

export class AuditService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getGroups() {
		try {
			const response = await this.axiosInstance.get<DocumentsGroupDTO[]>('/audit/groups');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os grupos de empresas`, error);
			return undefined;
		}
	}

	async createGroup(cnpj: string) {
		const data = { cnpj: cnpj }
		return await this.axiosInstance.post(`/audit/groups`, data);
	}

	async createAdmission(data: any) {
		const response = await this.axiosInstance
			.post<EmployeeDTO>(`/audit/groups/${data.groupId}/admission`, data);
		return { ...response };
	}

	async getAdmissions(id: string) {
		const response = await this.axiosInstance.get<AuditAdmissionDTO[]>(`/audit/groups/${id}/admissions`);
		return { ...response };
	}

	async getAdmission(id: string) {
		const response = await this.axiosInstance.get<AuditAdmissionDTO>(`/audit/admission/${id}`);
		return { ...response };
	}

	async getValidAdmission(id: string) {
		const response = await this.axiosInstance.get<AuditAdmissionDTO>(`/audit/admission/${id}/valid`);
		return { ...response };
	}

	async getRequiredDocuments(id: string) {
		try {
			const response = await this.axiosInstance.get<string[]>(`/audit/admission/${id}/required-documents`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os documentos obrigatórios`, error);
			return undefined;
		}
	}

	async createLog(id: string, data: any) {
		return await this.axiosInstance.post(`/audit/admission/${id}`, data);
	}

	async saveAdmission(admission: AuditAdmissionDTO, latitude: number | undefined,
			longitude: number | undefined, locationName: string | undefined) {
		return await this.axiosInstance.put(`/audit/admission?latitude=${latitude}&longitude=${longitude}&locationName=${locationName}`, admission);
	}

	async sendDocuments(id: string, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.post(`/audit/admission/${id}/documents`, form);
		return {...response};
	}

	async updateAdmissionStatus(id: string, statusInfo: AdmissionStatusDTO): Promise<void> {
		return await this.axiosInstance.put(`/audit/admission/${id}/status`, statusInfo);
	}

	async getDocument(id: string, data: AdmissionStatusDTO) {
		const response = await this.axiosInstance.post(`/audit/document/${id}`, data, {
			responseType: "blob",
		});
		return {...response};
	}

	async reopenLink(id: number, statusInfo: AdmissionStatusDTO) {
		const response = await this.axiosInstance.post(`/audit/admission/${id}/reopen`, statusInfo);
		return {...response};
	}
}